import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

type CompTagColor = 'purple' | 'gold' | 'green' | 'muted' | 'red';

const toneClasses: Record<CompTagColor, string> = {
	purple: 'bg-loomlite-purple/15 text-[#D9A9F5] border-loomlite-purple/35',
	gold: 'bg-loomlite-gold/10 text-loomlite-gold-soft border-loomlite-gold/35',
	green: 'bg-loomlite-green/10 text-[#5CE7A8] border-loomlite-green/30',
	muted: 'bg-slate-400/10 text-loomlite-muted border-loomlite-border',
	red: 'bg-red-500/10 text-red-300 border-red-500/30',
};

const dotColor: Record<CompTagColor, string> = {
	purple: 'bg-loomlite-purple-soft',
	gold: 'bg-loomlite-gold',
	green: 'bg-loomlite-green',
	muted: 'bg-loomlite-dim',
	red: 'bg-red-400',
};

interface CompTagProps {
	children: ReactNode;
	color?: CompTagColor;
	withDot?: boolean;
	className?: string;
}

export function CompTag({ children, color = 'purple', withDot = true, className }: CompTagProps) {
	return (
		<span
			className={cn(
				'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium uppercase tracking-[0.04em]',
				toneClasses[color],
				className,
			)}
		>
			{withDot && (
				<span
					className={cn('h-1.5 w-1.5 rounded-full', dotColor[color])}
					style={{ boxShadow: '0 0 8px currentColor' }}
				/>
			)}
			{children}
		</span>
	);
}
